const SHARE_CODE_HASH_PATTERN = /[#&]key=([^&]+)/;

export const parseLessonShareCodeFromHash = (): string | null => {
  if (typeof window === 'undefined') {
    return null;
  }
  const match = window.location.hash.match(SHARE_CODE_HASH_PATTERN);
  if (!match || !match[1]) {
    return null;
  }
  try {
    return decodeURIComponent(match[1]);
  }
  catch {
    return match[1];
  }
};
